import { useState, useEffect } from 'react';

let inflightPromise = null;

/** Single in-flight fetch shared across all hook instances (no stale module cache of the provider value). */
function fetchInstallmentsCheckoutProviderOnce() {
  if (!inflightPromise) {
    inflightPromise = fetch('/api/installments-checkout-provider', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : {}))
      .then((j) => {
        const p = j?.provider === 'defera_capital' ? 'defera_capital' : 'slice_pay';
        return p;
      })
      .catch(() => 'slice_pay')
      .finally(() => {
        inflightPromise = null;
      });
  }
  return inflightPromise;
}

/**
 * Platform setting: Slice Pay vs Defera Capital for standard installment checkout.
 * Returns `null` until the first fetch completes so callers don't treat `slice_pay` as real before /api responds.
 */
export function useInstallmentsCheckoutProvider() {
  const [provider, setProvider] = useState(null);

  useEffect(() => {
    fetchInstallmentsCheckoutProviderOnce().then(setProvider);
  }, []);

  return provider;
}
